import React, { useMemo } from "react";
import "./ExtraOrdinary.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { Link } from "react-router-dom";
import { useAboutSection } from "../../../../context/AboutPageContext";
import { useServicesSection } from "../../../../context/ServicesPageContext";
import { resolveMediaUrl } from "../../../../utils/resolveMediaUrl";
import { useCmsPageSection } from "../../../../hooks/useCmsPageSection";

const ExtraOrdinary = () => {
  const about = useAboutSection("extra");
  const services = useServicesSection("extra");
  const fromProvider = about.fromAboutPage || services.fromServicesPage;

  const fetched = useCmsPageSection("services", "extra", {
    skip: fromProvider,
  });

  const section = about.fromAboutPage
    ? about.section
    : services.fromServicesPage
      ? services.section
      : fetched.section;
  const loading = about.fromAboutPage
    ? about.loading
    : services.fromServicesPage
      ? services.loading
      : fetched.loading;

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url;
    return url ? resolveMediaUrl(url) : "";
  }, [section]);

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="extra">
      <div className="extra-card">
        {bgSrc ? <img src={bgSrc} alt="" className="extra-bg" /> : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}

        {fields.description ? (
          <RichTextContent content={fields.description} />
        ) : null}

        {fields.buttonLink ? (
          <Link to={fields.buttonLink} className="buttonclip extra-btn">
            <CmsText content={fields.buttonText} as="span" />
          </Link>
        ) : null}
      </div>
    </section>
  );
};

export default ExtraOrdinary;
